'use client'

import React, { useEffect, useRef } from 'react'
import QRCode from 'react-qr-code'
import { getClassNames } from '@helpers/productWidgetHelper'
import OverlayModal from '@components/OverlayModal/overlayModal'
import Image from 'next/image'
import { pageEvent, waitForAnalyticsLoad } from '@acko-tech/building-blocks.ui.acko-analytics'
import { SEGMENT } from '@components/MainWidget/common/widgetSegments'
import { fetchWidgetProductFn, widgetJourney } from '@configs/segmentEvents.config'
import { vehicleType } from '@components/WhatsappChallanFlow/helper'
import { FlipCard, GovernmentVerifiedBatch, NumberPlate } from '../Common/CommonComponents'
import styles from './DesktopChallanModal.module.scss'

interface DesktopChallanModaProps {
  show: boolean
  downloadUrl: string
  regNum: string
  title: string
  subtitle: string
  description: string
  ctaHelper: string
  QRTitle: string
  QRDescription: string
  cardData: Array<{ image: string; text: string }>
  onClose: () => void
  secondUIVersion?: boolean
  segmentEventCommonProperties: any
  widgetType: string
  vehicleInfoData: any
  variation: 'A' | 'B'
}

const DesktopChallanModal = ({
  show,
  downloadUrl,
  regNum,
  title,
  subtitle,
  description,
  ctaHelper,
  QRTitle,
  QRDescription,
  cardData,
  secondUIVersion,
  onClose,
  segmentEventCommonProperties,
  widgetType,
  vehicleInfoData,
  variation,
}: DesktopChallanModaProps) => {
  const hasFiredRef = useRef<boolean>(false)

  useEffect(() => {
    if (!hasFiredRef.current) {
      void waitForAnalyticsLoad().then(() => {
        void pageEvent(SEGMENT.VIEW_PAGE, {
          ...segmentEventCommonProperties,
          journey: widgetJourney[widgetType],
          product: fetchWidgetProductFn[widgetType]?.(),
          phone: vehicleInfoData?.mobile_number || '',
          registration_number: regNum || '',
          vehicle_type: vehicleType(vehicleInfoData),
          mm_name: vehicleInfoData?.vehicleInfo?.model_name || '',
          previous_policy_expiry_date: vehicleInfoData?.vehicleInfo?.previous_policy_expiry_detail || '',
          expiry_date: vehicleInfoData?.vehicleInfo?.previous_policy_expiry_detail || '',
          vas_amount: null,
          page_type: `challan_check_variation_${variation}`,
        })
        hasFiredRef.current = true
      })
    }
  }, [])
  return (
    <OverlayModal show={show} setShow={onClose}>
      <div
        className={getClassNames([styles.desktopChallanModal], {
          [styles.secondVersion]: !!secondUIVersion,
        })}>
        <div className={styles.modalContent}>
          <div className={styles.modalContentTop}>
            <NumberPlate regNum={regNum} />
            <p className={styles.modalTitle}>{title}</p>
            <p className={styles.modalSubTitle}>{subtitle}</p>
          </div>
          <div className={styles.modalContentBottom}>
            <div className={styles.QRContainer}>
              <div className={styles.QRContent}>
                <p className={styles.QRTitle}>{QRTitle}</p>
                <p className={styles.QRDescription}>{QRDescription}</p>
              </div>
              <QRCode className={styles.QRCode} value={downloadUrl} />
            </div>
            <p className={styles.descUnderButton}>{ctaHelper}</p>
          </div>
        </div>
        <div className={styles.modalRightContent}>
          <GovernmentVerifiedBatch />
          <FlipCard data={cardData} />
          <p className={styles.modalDescription}>
            {description?.split(/(<.*?>)/g)?.map((part, i) =>
              part.startsWith('<') && part.endsWith('>') ? (
                <span className={styles.bold} key={i}>
                  {part.slice(1, -1)}
                </span>
              ) : (
                <React.Fragment key={i}>{part}</React.Fragment>
              )
            )}
          </p>
        </div>
        <Image src="" alt="close-icon" height={20} width={20} onClick={onClose} className={styles.closeButton} />
      </div>
    </OverlayModal>
  )
}

export default DesktopChallanModal
